import { useLayoutEffect } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import "./App.scss";
import "./Chart.scss";
import Footer from "./components/Footer";
import Header from "./components/Header";
import TokenCTA from "./components/TokenCTA";
import Home from "./pages/home/Home";
import LaunchPad from "./pages/launchpad/LaunchPad";
import Staking from "./pages/staking/Staking";

function App() {
	const Wrapper = ({ children }) => {
		const location = useLocation();
		useLayoutEffect(() => {
			document.documentElement.scrollTo(0, 0);
		}, [location.pathname]);
		return children;
	};
	return (
		<>
			<BrowserRouter>
				<Wrapper>
					<Header />
					<Routes>
						<Route path="/" element={<Home />} />
						<Route path="/staking" element={<Staking />} />
						<Route path="/antex" element={<LaunchPad />} />
					</Routes>
					<TokenCTA />
					<Footer />
				</Wrapper>
			</BrowserRouter>
		</>
	);
}

export default App;
